<template>
  <div class="admin-user-header">
    <!-- User Info Block -->
    <div class="user-info-block">
      <div class="user-avatar">
        <img src="/static/img/central-gym50x50.webp" alt="AVATAR" />
        <div class="user-status-indicator"></div>
      </div>
      <div class="user-details">
        <h6 class="user-name">{{ this.username }}</h6>
        <p class="user-role">Administrador</p>
        <div class="user-status">
          <span class="status-dot"></span>
          <span class="status-text">En línea</span>
        </div>
      </div>
    </div>

    <!-- User Actions -->
    <div class="user-actions">
      <button class="user-action-btn" @click="editProfile" title="Mi Perfil">
        <i class="nc-icon nc-single-02"></i>
        <span class="action-text">Mi Perfil</span>
      </button>
      
      <button class="user-action-btn" @click="lock()" title="Bloquear Sesión">
        <i class="nc-icon nc-key-25"></i>
        <span class="action-text">Bloquear</span>
      </button>
      
      <button class="user-action-btn logout-btn" @click="logout" title="Cerrar Sesión">
        <i class="nc-icon nc-button-power"></i>
        <span class="action-text">Cerrar Sesión</span>
      </button>
    </div>
  </div>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";

export default {
  components: {
    CollapseTransition,
  },
  data() {
    return {
      isClosed: true,
      username: sessionStorage.getItem("WHbUjdv3TG"),
    };
  },
  methods: {
    toggleMenu() {
      this.isClosed = !this.isClosed;
    },
    logout() {
      this.$swal.fire({
        title: "Cerrar Sesión",
        html: `
          <div style="text-align: center;">
            <div style="font-size: 48px; color: #6bd098; margin-bottom: 20px;">
              <i class="nc-icon nc-button-power"></i>
            </div>
            <p style="margin-bottom: 15px; color: #666;">
              <strong>${this.username}</strong>
            </p>
            <p style="margin-bottom: 10px; color: #666;">
              ¿Estás seguro de que deseas cerrar tu sesión?
            </p>
            <p style="font-size: 14px; color: #999;">
              Se cerrará tu sesión actual y deberás iniciar sesión nuevamente.
            </p>
          </div>
        `,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#6c757d",
        confirmButtonText: '<i class="nc-icon nc-button-power"></i> Cerrar Sesión',
        cancelButtonText: '<i class="nc-icon nc-simple-remove"></i> Cancelar',
        backdrop: `
          rgba(0,26,0,0.4)
        `,
        allowOutsideClick: false,
        customClass: {
          popup: 'logout-modal',
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-secondary'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          this.performLogout();
        }
      });
    },
    performLogout() {
      this.$swal.fire({
        title: "Cerrando sesión...",
        text: "Finalizando tu sesión actual",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });

      // Simular un pequeño delay para dar sensación de procesamiento
      setTimeout(() => {
        // Limpiar completamente la sesión del navegador
        sessionStorage.clear();
        localStorage.clear();
        
        // Limpiar cualquier cookie relacionada con la sesión
        document.cookie.split(";").forEach(function(c) { 
          document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); 
        });
        
        this.$swal.fire({
          title: "¡Sesión cerrada!",
          text: "Tu sesión ha sido cerrada exitosamente",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        }).then(() => {
          // Redirigir al login y forzar recarga completa
          window.location.href = "/login";
        });
      }, 800);
    },
    editProfile(){
      this.$router.push('/admin/User')
    },
    lock(){
      this.$router.push('/Lock')
    }
  },
};
</script>
<style scoped>
/* Admin User Header Styles */
.admin-user-header {
  padding: 0;
  margin: 0;
  width: 100%;
}

/* User Info Block */
.user-info-block {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.user-avatar {
  position: relative;
  width: 50px;
  height: 50px;
  margin-right: 12px;
  flex-shrink: 0;
}

.user-avatar img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 2px solid rgba(255,255,255,0.3);
  object-fit: cover;
  background: white;
}

.user-status-indicator {
  position: absolute;
  bottom: 2px;
  right: 2px;
  width: 14px;
  height: 14px;
  background: #4CAF50;
  border: 2px solid white;
  border-radius: 50%;
}

.user-details {
  flex: 1;
  min-width: 0;
}

.user-name {
  color: white;
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 5px 0;
  line-height: 1.2;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.user-role {
  color: rgba(255,255,255,0.8);
  font-size: 12px;
  margin: 0 0 8px 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 500;
}

.user-status {
  display: flex;
  align-items: center;
  font-size: 11px;
  color: rgba(255,255,255,0.7);
}

.status-dot {
  width: 6px;
  height: 6px;
  background: #4CAF50;
  border-radius: 50%;
  margin-right: 5px;
}

/* User Actions */
.user-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.user-action-btn {
  background: rgba(255,255,255,0.1);
  border: 1px solid rgba(255,255,255,0.2);
  color: rgba(255,255,255,0.9);
  padding: 10px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  text-align: left;
  cursor: pointer;
  width: 100%;
}

.user-action-btn:hover {
  background: rgba(255,255,255,0.2);
  border-color: rgba(255,255,255,0.4);
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.user-action-btn:active {
  transform: translateY(0);
}

.user-action-btn:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(255,255,255,0.3);
}

.user-action-btn i {
  font-size: 14px;
  margin-right: 10px;
  width: 16px;
  text-align: center;
  flex-shrink: 0;
}

.action-text {
  flex: 1;
}

.logout-btn {
  background: rgba(220, 53, 69, 0.1);
  border-color: rgba(220, 53, 69, 0.3);
  color: #dc3545;
}

.logout-btn:hover {
  background: rgba(220, 53, 69, 0.2);
  border-color: #dc3545;
  color: #dc3545;
}

/* Responsive */
@media (max-width: 991px) {
  .user-avatar {
    width: 40px;
    height: 40px;
    margin-right: 10px;
  }
  
  .user-name {
    font-size: 14px;
  }
  
  .user-role {
    font-size: 11px;
  }
  
  .user-action-btn {
    padding: 8px 10px;
    font-size: 11px;
  }
  
  .user-action-btn i {
    font-size: 12px;
    margin-right: 8px;
  }
}

/* Sidebar minimizado */
.sidebar-mini .admin-user-header {
  text-align: center !important;
  padding: 0 !important;
  position: relative;
  overflow: visible;
  width: 100% !important;
  margin: 0 auto !important;
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
  align-items: center !important;
  box-sizing: border-box;
}

.sidebar-mini .user-info-block {
  flex-direction: column !important;
  margin-bottom: 6px;
  align-items: center !important;
  width: 100% !important;
  display: flex !important;
  justify-content: center !important;
}

.sidebar-mini .user-avatar {
  margin: 0 auto 6px auto !important;
  width: 32px;
  height: 32px;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.sidebar-mini .user-avatar img {
  border: 2px solid rgba(255,255,255,0.2);
}

.sidebar-mini .user-status-indicator {
  width: 12px;
  height: 12px;
}

.sidebar-mini .user-details {
  display: none;
}

.sidebar-mini .user-actions {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 3px;
  position: relative;
  width: 100% !important;
  transition: all 0.3s ease;
}

/* Expandir acciones cuando el sidebar está en hover */
.sidebar-mini .sidebar:hover .user-actions {
  align-items: flex-start;
  width: 140px;
  gap: 8px;
}

/* Mostrar los 3 botones siempre en modo colapsado */
.sidebar-mini .user-action-btn {
  display: flex !important;
  width: 28px;
  height: 28px;
  padding: 0;
  border-radius: 50%;
  min-width: 28px;
  min-height: 28px;
  background: rgba(255,255,255,0.15);
  border: 1px solid rgba(255,255,255,0.25);
  justify-content: center;
  align-items: center;
  position: static;
  overflow: hidden;
  cursor: pointer;
  margin: 0 auto !important;
  transition: transform 0.2s ease, background-color 0.2s ease, border-color 0.2s ease;
}

/* Iconos más pequeños en modo colapsado */
.sidebar-mini .user-action-btn i {
  margin: 0;
  font-size: 12px;
}

.sidebar-mini .user-action-btn .action-text {
  display: none;
  opacity: 0;
  white-space: nowrap;
  font-size: 11px;
  font-weight: 500;
  margin-left: 8px;
  transition: opacity 0.25s ease;
}

/* Mostrar todos los botones cuando el sidebar está en hover */
.sidebar-mini .sidebar:hover .user-action-btn {
  display: flex;
  width: auto;
  min-width: 120px;
  padding: 8px 12px;
  border-radius: 20px;
  justify-content: flex-start;
  background: rgba(255,255,255,0.2);
  border: 1px solid rgba(255,255,255,0.3);
  margin: 0;
  position: relative;
  z-index: 100;
  transition: background-color 0.2s ease, border-color 0.2s ease;
  pointer-events: auto;
}

.sidebar-mini .sidebar:hover .user-action-btn .action-text {
  display: inline-block;
  opacity: 1;
  margin-left: 8px;
  font-size: 11px;
  font-weight: 500;
}

.sidebar-mini .sidebar:hover .user-action-btn i {
  margin-right: 0;
  font-size: 14px;
  flex-shrink: 0;
}

/* Tooltips para todos los botones en modo colapsado */
.sidebar-mini .user-action-btn {
  position: relative;
}

.sidebar-mini .user-action-btn::after {
  content: attr(title);
  position: absolute;
  left: calc(100% + 8px);
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0,0,0,0.9);
  color: white;
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  z-index: 1000;
  pointer-events: none;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.sidebar-mini .user-action-btn::before {
  content: '';
  position: absolute;
  left: calc(100% + 3px);
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  border-right: 4px solid rgba(0,0,0,0.9);
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  z-index: 1000;
  pointer-events: none;
}

.sidebar-mini .user-action-btn:hover::after {
  opacity: 1;
  visibility: visible;
  left: calc(100% + 12px);
}

.sidebar-mini .user-action-btn:hover::before {
  opacity: 1;
  visibility: visible;
  left: calc(100% + 7px);
}

/* Ocultar tooltips cuando el sidebar está en hover */
.sidebar-mini .sidebar:hover .user-action-btn::after,
.sidebar-mini .sidebar:hover .user-action-btn::before {
  opacity: 0 !important;
  visibility: hidden !important;
}

/* Hover para todos los botones en modo colapsado */
.sidebar-mini .sidebar:not(:hover) .user-action-btn:hover {
  background: rgba(255,255,255,0.25);
  border-color: rgba(255,255,255,0.4);
  transform: scale(1.05);
}

.sidebar-mini .sidebar:not(:hover) .user-action-btn.logout-btn:hover {
  background: rgba(220, 53, 69, 0.3);
  border-color: rgba(220, 53, 69, 0.5);
}

/* Efectos hover sutiles cuando los botones están expandidos */
.sidebar-mini .sidebar:hover .user-action-btn:hover {
  background: rgba(255,255,255,0.3);
  border-color: rgba(255,255,255,0.4);
}

.sidebar-mini .sidebar:hover .user-action-btn.logout-btn:hover {
  background: rgba(220, 53, 69, 0.4);
  border-color: rgba(220, 53, 69, 0.5);
  color: #fff;
}
</style>

<style>
/* Estilos para el modal de logout */
.logout-modal {
  border-radius: 15px !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2) !important;
}

.logout-modal .swal2-title {
  color: #333 !important;
  font-weight: 600 !important;
  font-size: 24px !important;
}

.logout-modal .swal2-html-container {
  margin: 20px 0 !important;
}

.logout-modal .swal2-actions {
  gap: 15px !important;
}

.logout-modal .swal2-confirm {
  background-color: #dc3545 !important;
  border: none !important;
  border-radius: 25px !important;
  padding: 10px 20px !important;
  font-weight: 500 !important;
  transition: all 0.3s ease !important;
}

.logout-modal .swal2-confirm:hover {
  background-color: #c82333 !important;
  transform: translateY(-2px) !important;
}

.logout-modal .swal2-cancel {
  background-color: #6c757d !important;
  border: none !important;
  border-radius: 25px !important;
  padding: 10px 20px !important;
  font-weight: 500 !important;
  transition: all 0.3s ease !important;
}

.logout-modal .swal2-cancel:hover {
  background-color: #5a6268 !important;
  transform: translateY(-2px) !important;
}

.logout-modal .swal2-backdrop {
  background-color: rgba(0, 26, 0, 0.4) !important;
}
</style>
